import {
	FETCH_NI_PRODUCTION_BY_SMELTER,
	RESET_NI_PRODUCTION_BY_SMELTER
} from '../../actions';

export default (state = {}, action) => {
	switch (action.type) {
		case FETCH_NI_PRODUCTION_BY_SMELTER:
			return action.payload;
		case RESET_NI_PRODUCTION_BY_SMELTER:
			return {};
		default:
			return state;
	}
};
